import { render, staticRenderFns } from "./StudentCourse.vue?vue&type=template&id=218d568f&scoped=true"
import script from "./StudentCourse.vue?vue&type=script&lang=js"
export * from "./StudentCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d568f",
  null
  
)

export default component.exports